var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('datatable',{attrs:{"show_delete":false,"title":"Company History Companies","fields":_vm.fields,"response":_vm.data},on:{"create":_vm.createHistoryCompany,"edit_click":_vm.editClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }